import { type FormEvent, useState } from 'react'
import { api } from './api'

const LOGIN_EMAIL = 'keith@keith.ae'

export function Login({ onAuthenticated }: { onAuthenticated: () => void }) {
  const [step, setStep] = useState<'email' | 'code'>('email')
  const [code, setCode] = useState('')
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState('')

  async function requestCode(event: FormEvent) {
    event.preventDefault()
    setBusy(true)
    setError('')
    try {
      await api.requestCode(LOGIN_EMAIL)
      setStep('code')
    } catch (caught) {
      setError(caught instanceof Error ? caught.message : 'Could not request a code.')
    } finally {
      setBusy(false)
    }
  }

  async function verify(event: FormEvent) {
    event.preventDefault()
    setBusy(true)
    setError('')
    try {
      await api.verifyCode(LOGIN_EMAIL, code)
      onAuthenticated()
    } catch (caught) {
      setError(caught instanceof Error ? caught.message : 'The code could not be verified.')
    } finally {
      setBusy(false)
    }
  }

  return (
    <main className="login-shell">
      <section className="login-panel" aria-labelledby="login-title">
        <div className="brand-mark" aria-hidden="true">J</div>
        <p className="eyebrow">Private workspace</p>
        <h1 id="login-title">Jobs</h1>
        <p className="login-copy">{step === 'email' ? 'A focused place to move opportunities forward.' : `Enter the six-digit code sent to ${LOGIN_EMAIL}.`}</p>
        {step === 'email' ? (
          <form onSubmit={requestCode} className="login-form">
            <label htmlFor="email">Email</label>
            <input id="email" type="email" value={LOGIN_EMAIL} readOnly />
            <button className="primary-button" disabled={busy}>{busy ? 'Sending…' : 'Email me a code'}</button>
          </form>
        ) : (
          <form onSubmit={verify} className="login-form">
            <label htmlFor="code">Sign-in code</label>
            <input id="code" className="code-input" inputMode="numeric" autoComplete="one-time-code" pattern="[0-9]{6}" maxLength={6} autoFocus value={code} onChange={(event) => setCode(event.target.value.replace(/\D/g, ''))} />
            <button className="primary-button" disabled={busy || code.length !== 6}>{busy ? 'Checking…' : 'Continue'}</button>
            <button className="text-button" type="button" onClick={() => void requestCode({ preventDefault() {} } as FormEvent)}>Send another code</button>
          </form>
        )}
        {error && <p className="form-error" role="alert">{error}</p>}
      </section>
    </main>
  )
}
